import React, { useState } from "react";
import "./NewsletterSection.css";
import { useTranslation } from "react-i18next";

const NewsletterSection = () => {
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);

  const [formData, setFormData] = useState({
    nom: "",
    prenom: "",
    email: "",
    langue: "Français",
    isMember: "Non",
    message: "",
  });

  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");

    try {
      const response = await fetch("/mail.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus("success");
        setFormData({
          nom: "",
          prenom: "",
          email: "",
          langue: "Français",
          isMember: "Non",
          message: "",
        });
      } else {
        setStatus("error");
      }
    } catch (error) {
      console.error(error);
      setStatus("error");
    }
  };

  return (
    <section className="newsletter-section">
      {!isOpen && (
        <button
          className="newsletter-trigger-btn"
          onClick={() => setIsOpen(true)}
        >
          {t("newsletter.title")}
        </button>
      )}

      {isOpen && (
        <div className="newsletter-container fade-in-up">
          <p
            style={{ textAlign: "center", color: "#ccc", marginBottom: "20px" }}
          >
            {t("newsletter.subtitle")}
          </p>

          <form className="newsletter-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>{t("newsletter.fields.lastname")} *</label>
                <input
                  type="text"
                  name="nom"
                  required
                  className="newsletter-input"
                  value={formData.nom}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>{t("newsletter.fields.firstname")} *</label>
                <input
                  type="text"
                  name="prenom"
                  required
                  className="newsletter-input"
                  value={formData.prenom}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="form-group">
              <label>{t("newsletter.fields.email")} *</label>
              <input
                type="email"
                name="email"
                required
                className="newsletter-input"
                value={formData.email}
                onChange={handleChange}
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>{t("newsletter.fields.language")}</label>
                <select
                  name="langue"
                  className="newsletter-select"
                  value={formData.langue}
                  onChange={handleChange}
                >
                  <option value="Français">Français</option>
                  <option value="Anglais">English</option>
                </select>
              </div>
            </div>

            <div className="form-group">
              <label>{t("newsletter.fields.is_member")}</label>
              <div className="radio-group">
                <label className="radio-label">
                  <input
                    type="radio"
                    name="isMember"
                    value="Oui"
                    checked={formData.isMember === "Oui"}
                    onChange={handleChange}
                  />
                  {t("newsletter.fields.yes")}
                </label>
                <label className="radio-label">
                  <input
                    type="radio"
                    name="isMember"
                    value="Non"
                    checked={formData.isMember === "Non"}
                    onChange={handleChange}
                  />
                  {t("newsletter.fields.no")}
                </label>
              </div>
            </div>

            <div className="form-group">
              <label>{t("newsletter.fields.message")}</label>
              <textarea
                name="message"
                rows="3"
                className="newsletter-textarea"
                value={formData.message}
                onChange={handleChange}
              ></textarea>
            </div>

            <div className="btn-group">
              <button
                type="submit"
                className="newsletter-btn"
                disabled={status === "sending"}
              >
                {status === "sending" ? "..." : t("newsletter.fields.submit")}
              </button>

              <button
                type="button"
                className="close-btn"
                onClick={() => setIsOpen(false)}
              >
                Fermer
              </button>
            </div>

            {status === "success" && (
              <p className="form-message success">
                {t("newsletter.fields.success")}
              </p>
            )}
            {status === "error" && (
              <p className="form-message error">
                {t("newsletter.fields.error")}
              </p>
            )}
          </form>
        </div>
      )}
    </section>
  );
};

export default NewsletterSection;
